module.exports = __webpack_public_path__ + "static/media/text_1.7f50c905.png";